// extracted by mini-css-extract-plugin
module.exports = {"item":"W2Users_item__zU9UL","item__icon":"W2Users_item__icon__RjCwh","item__title":"W2Users_item__title__CuhwE"};